import React, { useEffect, useMemo } from "react";
import { SelectForm } from "../../../Buttons";
import TextInputModal from "../../../TextInputModal";
import { orderTypeMount, show_parcels } from "../../../../../helpers/OrdersFunctionsGlobal";
import SelectParcelTerminalInput from "../../../../globals/SelectParcelTerminalInput";
import { useCallback } from "react";

function RenderDelivery({
  onHandleChangeAddress,
  carriers,
  general,
  onChange,
  payment_types,
  total_shipping,
  onChangeTotals,
  errors,
  shipping_address,
  shops = []
}) {
  const Shops = shops.filter(({label}) => label !== 'TB EE');

  const current_carrier = useMemo(() => {
    const c_carrier = carriers.find((item) => item.id === general.carrier_id);
    if (!c_carrier) return null;
    const { order_type, delivery } = orderTypeMount(
      c_carrier,
      shipping_address.parcel_terminal_id
    );
    return {
      order_type,
      delivery,
      carrier: c_carrier
    }
  }, [general.carrier_id, carriers])

  const activeParcelTerminal = useMemo(() => {
    if (!current_carrier) return false;
    return show_parcels(current_carrier.order_type, current_carrier.delivery)
  }, [current_carrier])


  useEffect(() => {
    onHandleChangeAddress(
      {
        parcel_terminal_id: null,
      },
      "shippingAddress"
    );
  }, [general.carrier_id]);

  const onChangeCarrier = (value) => {
    onChange(
      {
        carrier_id: value,
      },
      true
    );

  };

  const onChangeParcelTerminal = useCallback((value) => {
    onHandleChangeAddress(
      {
        city: "",
        postal_code: "",
        street: "",
        parcel_terminal_id: value,
      },
      "shippingAddress"
    );

  }, [])


  return (
    <React.Fragment>
      <div className="col-12">
        <SelectForm
          require={true}
          placeholder="Store"
          options={Shops}
          dropdownMatchSelectWidth={false}
          value={general.order_shop_id}
          onChange={(value, arg) => {
            console.log({ value, arg })
            onChange(
              {
                order_shop_id: value,
                carrier_id: undefined,
                payment: undefined
              },
              true
            );
            onHandleChangeAddress(
              {
                parcel_terminal_id: undefined,
              },
              "shippingAddress"
            );
          }}
          error={errors?.order_shop_id?.length > 0 ? "Required field" : ""}
        />
      </div>
      <div className="col-12">
        <SelectForm
          require={true}
          placeholder="Payment"
          disabled={!general.order_shop_id}
          options={payment_types.filter(
            (e) => e.order_shop_id == general.order_shop_id && e.value
          )}
          dropdownMatchSelectWidth={false}
          value={general.payment}
          onChange={(value) => onChange({ target: { name: "payment", value } })}
          error={errors?.payment?.length > 0 ? "Required field" : ""}
        />
      </div>
      <div className="col-12">
        <TextInputModal
          require={true}
          type="number"
          text="Delivery price"
          placeholder="Enter"
          name="total_shipping"
          value={total_shipping}
          onChange={onChangeTotals}
        // disabled={carrierType.module_name == "fspickupatstorecarrier"}
        />
      </div>
      <div className="col-12">
        <SelectForm
          disabled={!general.order_shop_id}
          require={true}
          placeholder="Delivery method"
          options={carriers
            .filter((e) => e.order_shop_id == general.order_shop_id)
            .map((e) => ({ ...e, value: e.id }))}
          dropdownMatchSelectWidth={false}
          value={general.carrier_id}
          onChange={(value) => onChangeCarrier(value)}
          error={errors?.carrier?.length > 0 ? "Required field" : ""}
        />
      </div>
      {activeParcelTerminal && (
        <div className="col-12">
          <SelectParcelTerminalInput
            label="Parcel terminal"
            value={shipping_address.parcel_terminal_id}
            shipment_type={current_carrier.order_type}
            delivery={current_carrier.delivery}
            country_id={shipping_address.country_id}
            onChange={onChangeParcelTerminal}
            error={errors.parcel_terminal_id}
          />
        </div>
      )}
    </React.Fragment>
  );
}
export default RenderDelivery;
